export default "__VITE_ASSET__D9D_nbxT__"